// extracted by mini-css-extract-plugin
module.exports = {"Button":"edit-published-news-modal_Button__W93jd"};